import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

export interface RoomDetailsRoomScoreInterface {
  roomScore?: string;
}

export const RoomDetailsRoomScore: React.FunctionComponent<RoomDetailsRoomScoreInterface> = ({ roomScore }) =>
  roomScore ? (
    <div className="uitk-type-300 pwa-theme--grey-700 all-b-padding-two" data-stid="room-score-text">
      <LocalizedText message="hotels.infosite.roomInfoDialog.roomDetails.roomscore.mainText" data={[roomScore]} />
    </div>
  ) : null;
